module.exports = __webpack_public_path__ + "static/img/background.b8b991e1.svg";